import { validators } from '../utils';
import { makeFormComponent, makeFormHook } from '../utils/factory';
import type { InferFormType } from '../utils/types';

/**
 * Profile completion form schema for post-signup onboarding.
 * Collects phone number and birthday after account creation.
 */
export const profileCompletionFormSchema = validators.object({
  birthday: validators.birthdateAdult(),
  isSmsMarketingOptedIn: validators.boolean(),
  phoneNumber: validators.e164PhoneNumber(),
});

export type ProfileCompletionFormSchema = InferFormType<typeof profileCompletionFormSchema>;

export const profileCompletionFormDefaultValues = {
  birthday: '' as DateISOString,
  isSmsMarketingOptedIn: false,
  phoneNumber: '',
} satisfies ProfileCompletionFormSchema;

export const useProfileCompletionForm = makeFormHook(profileCompletionFormSchema, profileCompletionFormDefaultValues);

export const ProfileCompletionForm = makeFormComponent(profileCompletionFormSchema, profileCompletionFormDefaultValues);
